<template lang="pug">
	.network-show--clocks-list.flex-col.space
		ListView.full-width.no-padding(
			ref="list",
			initialView="cards",
			:getTotal="(r) => r.TotalNumberOfRecords",
			:getItems="(r) => prepareClocksResult(r.Results)",
			:getData="(pIdx, limit, opts) => $Data.getNetworkShowClocks(pIdx, limit, opts, networkShowId)",
			:filterRow="true",
			:remoteSorting="true",
			:hideViewsSelection="true",
			:autoFit="true",
			:heightDelta="50",
			:showColumnHeaders="false",
			:searchVisible="true",
			:topPagerVisible="false"
		)
			template(v-slot:left-actions="{ data }")
				.flex-row.space-medium.align-center
					.font-big.upper.grey {{$tCaption('Clocks')}}
					DxButton(icon="plus", :hint="$tCaption('New clock')", @click="newClock")
			template(v-slot:card="{ data }")
				.flex-col.space.clock-item.clickable.hoverable(@click="editClock(data)")
					.flex-row.space.align-center
						fas(icon="fa-regular fa-clock")
						.upper.font-lg(v-if="data.EffectiveDate") {{getClockDate(data).format('LLL')}}
						.upper.font-lg {{data.Name || $tCaption('Clock')}}
					.grey(v-if="data.Description") {{data.Description}}
					.flex-row.space.align-center
						DxButton(:text="$tCaption('Edit clock in network studio')", icon="fas fa-arrow-right", @click="e => { e.event.stopPropagation(); openCreative(data) }", stylingMode="text")
		Popup(v-if="editingPopup.visible", :popupVisible="editingPopup.visible", :width="620", :height="500", :title="editingPopup.clock.Oid ? $tCaption('Network show clock') : $tCaption('New clock')")
			.flex-col.space-medium
				ClockDetail(:item="editingPopup.clock", :class="{ 'disabled-controls': editingPopup.loading }")
				Loader(v-if="editingPopup.loading", text="", :fullscreen="true")
			template(slot="actions-left")
				DxButton(v-if="editingPopup.clock.Oid", :text="$tCaption('Delete', '@actions')", @click="deleteClock(editingPopup.clock.Oid)", type="danger", :disabled="!!editingPopup.loading")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="editingPopup.visible = false")
				DxButton(:text="$tCaption('Save', '@actions')", @click="processEditingClock", type="success", :disabled="!!editingPopup.loading")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import EditableLabelField from 'app-core/EditableLabelField.vue';
	import Popup from 'app-core/Popup.vue';
	import ListView from 'app-core/ListView.vue';
	import ClockDetail from './ClockDetail.vue';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'networkShow.ClocksList',
		name: 'network-show--clocks-list',
		props: ['networkShowId'],
		components: {
			EditableLabelField, DxButton, Popup, ListView, ClockDetail, Loader
		},
		data() {
			return {
				editingClock: null,
				editingPopup: {
					visible: false,
					clock: null,
					loading: false
				}
			};
		},
		mounted() {
			if (__DEBUG__)
				window.networkShowClocks = this;
		},
		methods: {
			openCreative(clock) {
				this.$router.push({ name: 'creative-detail', params: { 
					creativeId: clock.Creative?.Oid,
					opts: {
						networkStudio: true,
						backLink: {
							name: clock.Name || this.$tCaption('Clock'),
							route: { path: `/network-studio/show/${this.networkShowId}`, query: { tab: 'clocks' } }
						}
					}
				}});
			},
			getClockDate(clock) {
				const date = this.$moment(clock.EffectiveDate).startOf('day');
				date.set('hours', clock.Hour)
				return date;
			},
			prepareClocksResult(r) {
				r.map(f => {
					f.NetworkShow = f.NetworkShow || {
						Oid: this.networkShowId
					}
				});
				return r;
			},
			editClock(clock) {
				this.editingPopup.visible = false;
				this.editingPopup.clock = clock;
				this.$nextTick(() => this.editingPopup.visible = true);
			},
			newClock() {
				this.editClock({
					Description: null,
					NetworkShow: {
						Oid: this.networkShowId
					},
					EffectiveDate: new Date(),
					Hour: 12,
					Name: null,
					Oid: null
				});
			},
			processEditingClock() {
				this.editingPopup.loading++;
				this.$Data.createUpdateNetworkShowClock(this.editingPopup.clock).then(() => {
					this.editingPopup.visible = false;
					this.$refs.list.reload();
				}).finally(() => this.editingPopup.loading--);
			},
			deleteClock(id) {
				this.$confirm().then(() => {
					this.editingPopup.loading++;
					this.$Data.deleteNetworkShowClock(id).then(() => {
						this.editingPopup.visible = false;
						this.$refs.list.reload();
					}).finally(() => this.editingPopup.loading--);
				});
			}
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.network-show--clocks-list {
		.card {
			flex: auto !important;
			width: 100%;
			margin: 0px;
			padding: 10px 0px;
			border-bottom: 1px solid #eaeaea;
		}
	}
</style>
